import { render, staticRenderFns } from "./ResponsibleCard.vue?vue&type=template&id=7f9227d3&"
import script from "./ResponsibleCard.vue?vue&type=script&lang=js&"
export * from "./ResponsibleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports